<template>
  <el-dialog
    class="project-progress"
    :title="step"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :modal="false"
    width="calc(100vw - 200px)"
  >
    <div class="header mb10">
      <div style="width:40%">
        <span class="mr5"
          ><span class="bolder">项目创建时间：</span>{{ dateFormat(project.createdAt, 'yyyy-mm-dd') }}</span
        >
        <span class="mr5"
          ><span class="bolder">进展天数：</span>{{ passed(project.startTime || project.createdAt) }}天</span
        >
      </div>
      <div style="width:60%">
        <span class="mr10 keep-all"
          ><span class="bolder">客户开发：</span>{{ (project['客户开发'] || []).join('、') }}</span
        >
        <span class="mr10 keep-all"
          ><span class="bolder">项目对接：</span>{{ (project['项目对接'] || []).join('、') }}</span
        >
        <span class="mr10 keep-all"
          ><span class="bolder">项目经理：</span>{{ (project['项目经理'] || []).join('、') }}</span
        >
        <span class="mr10 keep-all"
          ><span class="bolder">项目成员：</span>{{ (project['项目成员'] || []).join('、') }}</span
        >
      </div>
    </div>
    <div v-if="step === '项目创建'" class="content">
      <p>以下为项目相关信息填写情况，填写完成为对勾，空白为未填写</p>
      <div class="project-detail-box">
        <span v-for="item in projectDetail" :key="item.label" class="project-detail">
          <el-tooltip effect="dark" :content="getTemplate(item)" placement="top">
            <span @click="showProject"><input v-model="item.value" type="checkbox" :disabled="true" /> {{ item.label }}</span>
          </el-tooltip>

        </span>
        <!-- <el-checkbox v-for="item in projectDetail" :key="item.label" v-model="item.value" :disabled="true">{{item.label}}</el-checkbox> -->
      </div>
    </div>
    <div v-else-if="step === '人才搜寻'" class="content">
      <p class="bolder mb10">加入项目人选：{{ radishProjectDetail.已搜寻 }}人</p>
      <div class="mb10" style="display: flex;justify-content: space-around;">
        <p style="width:45%"><span class="bolder">来自行业：</span>{{ (radishProjectDetail.行业 || []).join('、') }}</p>
        <p style="width:45%"><span class="bolder">来自公司：</span>{{ (radishProjectDetail.公司 || []).join('、') }}</p>
      </div>
      <p class="bolder mb10">已沟通人选：{{ radishProjectDetail.已沟通 }}人</p>
    </div>
    <div v-else-if="step === '职位推荐'" class="content">
      <radishListPro ref="radishListPro" :hide-tab="true" default-tab="已推荐" :pid="project._id" />
    </div>
    <div v-else-if="step === '面试阶段'" class="content">
      <radishListPro ref="radishListPro" :hide-tab="true" default-tab="面试" :pid="project._id" />
    </div>
    <div v-else-if="step === 'offer谈判'" class="content">
      <radishListPro ref="radishListPro" :hide-tab="true" default-tab="offer" :pid="project._id" />
    </div>
    <div v-else-if="step === '离职管理'" class="content">
      <radishListPro ref="radishListPro" :hide-tab="true" default-tab="到岗" :pid="project._id" />
    </div>
    <div v-else-if="step === '开票催款'" class="content"></div>
    <!-- <span slot="footer" class="dialog-footer">
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="dialogVisible = false">取 消</div>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="confirm">确 定</div>
    </span> -->
  </el-dialog>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  data() {
    return {
      dialogVisible: false,
      project: {},
      step: null,
      projectDetail: [],
      radishProjectDetail: {},
    }
  },
  computed: {
    defaultTab() {
      return this.$route.query.tab || ''
    },
  },
  methods: {
    showProject() {
      window.open(`${window.origin}/#/project20/${this.project._id}?defaultActiveTab=详情`)
    },
    getTemplate(item) {
      return `${item.已填写.length > 0 ? `已填写：${item.已填写.join('、')}   |   ` : ''}${
        item.未填写.length > 0 ? `未填写：${item.未填写.join('、')}` : ''
      }`
    },
    confirm() {
      this.dialogVisible = false
    },
    async open(project, step) {
      this.project = project
      this.step = step
      this.dialogVisible = true
      this.checkProjectDetail()
      if (step === '人才搜寻') this.countRadishes()
    },
    async countRadishes() {
      const searchRadishDetail = {}
      const radishProject = this.project.radish_project || []

      searchRadishDetail.已搜寻 = radishProject.length
      const haveContacted = radishProject.filter(v => v.意向)
      searchRadishDetail.已沟通 = haveContacted.length
      const res = await app.service('radish').findByIds({ ids: radishProject.map(item => item.rid) })
      if (res.status === 'success') {
        const radishes = res.data
        searchRadishDetail.行业 = radishes.map(val => val.行业).filter(val => val)
        searchRadishDetail.公司 = radishes.map(val => val.公司).filter(val => val)
      } else this.$message.error(res.msg)
      const setObjIndustry = new Set(searchRadishDetail.行业)
      const setObjCompany = new Set(searchRadishDetail.公司)
      searchRadishDetail.行业 = [...setObjIndustry]
      searchRadishDetail.公司 = [...setObjCompany]
      this.radishProjectDetail = searchRadishDetail
    },
    checkProjectDetail() {
      const result = []
      const map = {
        项目JD: ['岗位职责', '岗位要求'],
        核心要求: ['核心要求'],
        客户关心问题: ['关注问题'],
        寻访方向: ['寻访方向'],
        客户关键决策人: ['关键面试人'],
        // '优势亮点（公司）':[],
        '优势亮点（项目）': ['职位亮点及优势'],
        阿尔法对公司认知: ['阿尔法认知'],
        面试流程及安排: ['面试安排'],
        项目标签: ['职能模块', '擅长方向', '细分职能', '目标行业', '平台', '职级', '业绩', '地域', '年龄要求', '标签'],
      }
      for (const label in map) {
        const fields = map[label]
        const obj = { label, value: false, 已填写: [], 未填写: [] }
        fields.forEach(field => {
          const val = this.project[field]
          if (Array.isArray(val)) {
            if (val.length !== 0) {
              obj.value = true
              obj.已填写.push(field)
            } else obj.未填写.push(field)
          } else if (val) {
            obj.value = true
            obj.已填写.push(field)
          } else obj.未填写.push(field)
        })
        result.push(obj)
      }
      console.log(result)
      this.projectDetail = result
    },
    dateFormat(time, format) {
      return dateFormat(time, format)
    },

    passed(date) {
      return date ? `${Math.ceil((Date.now() - date) / (24 * 3600 * 1000))}` : ''
    },
  },
}
</script>
<style>
.project-progress .el-dialog {
  display: flex;
  flex-direction: column;
}
.project-progress .el-dialog .el-dialog__body {
  overflow: auto;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.project-progress .el-dialog .el-dialog__body .content {
  overflow: auto;
  flex-grow: 1;
}
</style>
<style scoped>
.bolder {
  font-weight: 700;
}
.header {
  display: flex;
  justify-content: space-between;
}
.keep-all {
  word-break: keep-all;
  white-space: nowrap;
}
.project-detail-box {
  padding-top: 15px;
  display: flex;
  flex-wrap: wrap;
}
.project-detail {
  width: 25%;
  display: flex;
  align-items: center;
  padding: 6px;
}
</style>
